<template>
  <input type="button" class="btn logout" value="ログアウト" @click="clickBtnLogout">
</template>

<script>
import axios from "axios";

export default {
  name: 'Btn-Logout',
  props: {},
  methods: {
    clickBtnLogout:async function(){
      const path = '/logout'
      const params = new URLSearchParams();
      params.append('request', "true")
      // ログアウト認証成功後Loginページへ遷移
      let router = this.$router
      await axios.post(path, params, { withCredentials: true },)
          .then(function (res) {
            if(res.data.result === true){
              router.push('/login')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logout {

}

</style>
